module.exports = __webpack_public_path__ + "static/img/pbrand4.7b38f638.png";